/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GenerateEventCodeRequest} from '../models/GenerateEventCodeRequest';
import type {GenerateEventDescriptionRequest} from '../models/GenerateEventDescriptionRequest';

export interface GenerateEventCode$Request {
    generateEventCodeRequest: GenerateEventCodeRequest;
}

export interface GenerateEventCode$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const generateEventCodeRequest = createAction<PayloadData<void, GenerateEventCode$Request>>('EVENT_DATA_GENERATOR_CONTROLLER__GENERATE_EVENT_CODE__REQUEST');
export const generateEventCodeSuccess = createAction<PayloadData<string, GenerateEventCode$Request>>('EVENT_DATA_GENERATOR_CONTROLLER__GENERATE_EVENT_CODE__SUCCESS');
export const generateEventCodeFailure = createAction<PayloadData<Error, GenerateEventCode$Request, true>>('EVENT_DATA_GENERATOR_CONTROLLER__GENERATE_EVENT_CODE__FAILURE');

export const generateEventCodeActions = [
    generateEventCodeRequest,
    generateEventCodeSuccess,
    generateEventCodeFailure
] as const;

/**
 * @param {GenerateEventCodeRequest} meta.generateEventCodeRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const generateEventCode = (meta: GenerateEventCode$Request, config?: GenerateEventCode$Config) => {
    return {
        CALL_API: {
            types: generateEventCodeActions,
            method: ApiMethods.POST,
            endpoint: `/ai/event-code-generator/run`,
            TRANSPORT_REQUEST_BODY: meta.generateEventCodeRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/plain, application/json',
            }
        },
        ...meta
    }
};

export interface GenerateEventDescription$Request {
    generateEventDescriptionRequest: GenerateEventDescriptionRequest;
}

export interface GenerateEventDescription$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const generateEventDescriptionRequest = createAction<PayloadData<void, GenerateEventDescription$Request>>('EVENT_DATA_GENERATOR_CONTROLLER__GENERATE_EVENT_DESCRIPTION__REQUEST');
export const generateEventDescriptionSuccess = createAction<PayloadData<string, GenerateEventDescription$Request>>('EVENT_DATA_GENERATOR_CONTROLLER__GENERATE_EVENT_DESCRIPTION__SUCCESS');
export const generateEventDescriptionFailure = createAction<PayloadData<Error, GenerateEventDescription$Request, true>>('EVENT_DATA_GENERATOR_CONTROLLER__GENERATE_EVENT_DESCRIPTION__FAILURE');

export const generateEventDescriptionActions = [
    generateEventDescriptionRequest,
    generateEventDescriptionSuccess,
    generateEventDescriptionFailure
] as const;

/**
 * @param {GenerateEventDescriptionRequest} meta.generateEventDescriptionRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const generateEventDescription = (meta: GenerateEventDescription$Request, config?: GenerateEventDescription$Config) => {
    return {
        CALL_API: {
            types: generateEventDescriptionActions,
            method: ApiMethods.POST,
            endpoint: `/ai/event-description-generator/run`,
            TRANSPORT_REQUEST_BODY: meta.generateEventDescriptionRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/plain, application/json',
            }
        },
        ...meta
    }
};

